const EventType = {
  COACHING_ACTIVITY: 'coachingActivity',
  CLIENT_ACTIVITY: 'clientActivity',
};

const ChatActivity = {
  CHAT_MESSAGE_SENT: 'chatMessageSent',
};

const ChatActionsTypes = {
  CHECKING_FEEDBACK: 'checkingFeedback',
  GENERAL: 'general',
};

function getChatActionType(text) {
  switch (true) {
    case text.includes('[Check-in Feedback]'):
      return ChatActionsTypes.CHECKING_FEEDBACK;

    default:
      return ChatActionsTypes.GENERAL;
  }
}

export {
  EventType,
  ChatActivity,
  ChatActionsTypes,
  getChatActionType,
};
